/** Shared constants for Configure → Business screens. */

export const MAPPING_STATUS = {
    AUTO: 'auto-mapped',
    MANUAL: 'manual'
};

export const FILTER_ALL = 'all';

export const ENTITY_COLLECTION = {
    business: 'businesses',
    function: 'functions',
    kpi: 'kpis',
    model: 'models'
};

export const PRIO_OPTS = [
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
];

const PRIO_VALUES = new Set(PRIO_OPTS.map((o) => o.value));

/** Normalize priority for UI selects + API payloads (case-insensitive). */
export function normalizePriority(priority, fallback = 'low') {
    const value = String(priority || '').trim().toLowerCase();
    if (PRIO_VALUES.has(value)) return value;
    return fallback;
}

/** Match a PRIO_OPTS option for a stored/API priority value. */
export function findPriorityOption(priority) {
    const value = String(priority || '').trim().toLowerCase();
    return PRIO_OPTS.find((o) => o.value === value) || null;
}

export const MODEL_KINDS = [
    { value: 'Forecasting', label: 'Forecasting' },
    { value: 'Anomaly Detection', label: 'Anomaly Detection' },
    { value: 'Classification', label: 'Classification' },
    { value: 'Regression', label: 'Regression' },
    { value: 'Optimization', label: 'Optimization' },
    { value: 'Recommendation', label: 'Recommendation' }
];

export const ENTITY_KEYS = Object.keys(ENTITY_COLLECTION);

/** Normalize mapping status used by pills, filters, and metrics. */
export function normalizeMappingStatus(status) {
    return status === MAPPING_STATUS.MANUAL ? MAPPING_STATUS.MANUAL : MAPPING_STATUS.AUTO;
}

export function entityCollectionKey(type) {
    return ENTITY_COLLECTION[type] || null;
}
